<template>

    <main class="main" style="margin-top: 150px">
        <div class="container mt-20 min-h-700px">
            <div class="row mt-20 justify-content-center match-height">
                <div class="col-md-12 mt-10 mb-4" v-if="loading">
                    <paragraph-shimmer :lines="3" :random-size="true"/>
                </div>
                <div class="col-md-12 mt-3" v-if="event">

                    <div class="row justify-content-center">
                        <div class="col-md-8">
                            <carousel :autoplay="5000" :loop="true" :infinite="true" :itemsToShow="1" class="mb-4">
                                <slide v-for="(_newImage,_key) in (event.detailed_images || [])" :key="_key">
                                    <div class="carousel__item text-start  w-100">
                                        <img :src="$helpers.getImagePath(store.getters['moduleCommon/getConfigImagePath']+_newImage)"
                                             class="img-thumbnail h-350px w-100" alt="">
                                    </div>
                                </slide>

                                <template #addons>
                                    <pagination/>
                                </template>
                            </carousel>
                        </div>
                    </div>

                    <h2 class="mt-5" v-if="i18n.locale.value == 'ar'">{{event.title.ar}}</h2>
                    <h2 class="mt-5" v-if="i18n.locale.value == 'en'">{{event.title.en}}</h2>
                    <p>
                        <i class="uil uil-calendar-alt"></i>
                        {{$helpers.formatDate(event.createdAt)}}</p>

                    <template v-if="event.content">
                        <div class="mt-2" v-if="i18n.locale.value == 'ar'" v-html="event.content.ar"></div>
                        <div class="mt-2" v-if="i18n.locale.value == 'en'" v-html="event.content.en"></div>
                    </template>
                    <br><br><br><br>
                </div>
            </div>
        </div>
    </main>
</template>

<script lang="ts">
  import { defineComponent, reactive, toRefs, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { useI18n } from 'vue-i18n';
  import { useRouter, useRoute } from 'vue-router';
  import 'vue3-carousel/dist/carousel.css';
  import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';

  export default defineComponent({
    name: 'News',
    components: { Carousel, Slide, Pagination, Navigation },
    setup() {
      const store = useStore();
      const i18n = useI18n();
      const router = useRouter();
      const route = useRoute();

      const state = reactive({
        loading: false,
        event: null,
      });

      onMounted(() => {
        let id: any = route.params.id;
        findEvent(id);
      });

      const findEvent = (id) => {
        state.loading = true;
        store.dispatch('moduleCommon/findEvent', {
          id: id,
        }).then((response) => {
          state.loading = false;
          state.event = response.data;
        }).catch(() => {
          state.loading = false;
        });
      };

      return {
        ...toRefs(state),
        store,
        i18n,
      };
    },
  });
</script>
<style>

    .carousel__item {
        min-height: 150px;
        width: 100%;
        margin: 10px;
    }

    .carousel__slide {
        padding: 0;
    }

</style>

